<template>
  <div>
    <page-title>Dashboard Management</page-title>

    <main>
      <p>This section allows you to manage the layout of user dashboards.  You can specify widgets to display in specific areas of the dashboards of all users.</p>

      <base-button @click="launchEditor" primary="true">Open editor</base-button>
    </main>
  </div>
</template>

<script>
  export default {
    name: "DashboardAdmin",
    methods: {
      launchEditor() {
        //TODO: New window?
        this.$router.push({
          name: "DashboardAdminEdit"
        })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>